import { injectable } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import * as SerializationApi from '@/app/state-serialization/api'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';
import { HotspotState } from './hotspot-interfaces';

@injectable()
export class HotspotStateProtobufSerializer implements SerializationApi.StateSerializationPlugin<HotspotState> {

  key = { id: 36, name: { ns: 'interaction-suspend-data', name: 'hotspot' }, format: 'protobuf' }

  serialize(data: HotspotState): Result<Uint8Array, SerializationApi.SerializerError> {

    const message = new HotspotStateProtoMessage({
      touched: data.touched,
      activeIndex: data.activeIndex,
    })

    return ProtobufSerializer.serialize<HotspotStateProtoMessage>(message, HotspotStateProtoMessage)
  }

  deserialize(content: Uint8Array): Result<HotspotState, SerializationApi.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<HotspotStateProtoMessage>(content, HotspotStateProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const message = deserializeResult.value
    const result: HotspotState = {
      touched: message.touched,
      activeIndex: message.activeIndex,
    }
    
    return ok(result)
  }
}

@Type.d('HotspotStateProtoMessage')
class HotspotStateProtoMessage extends Message<HotspotStateProtoMessage> {
  @Field.d(1, 'bool', 'repeated')
  touched: boolean[];

  @Field.d(2, 'int32', 'optional', -1)
  activeIndex: number;
}
